import { useAuth } from "@app/shared";
import { FC } from "react";
import { TabbedDashLayout } from "../layouts/TabbedDashLayout";
import { EventTriggerTable, ClientEndpointTable } from "@app/shared/src/components/Integrations";

export const ClientEndpoints: FC = (props) => {
    const { currentOrganizationId } = useAuth();   

    return (
        <TabbedDashLayout centerChildren="Integrations"
            tabs={[
                { title: "Triggers", child: <EventTriggerTable organizationId={currentOrganizationId ?? ""} /> },
                { title: "Endpoints", child: <ClientEndpointTable organizationId={currentOrganizationId ?? ""} /> },
                // { title: "History", child: <>History</> },
            ]}
        />
    );
}